import script from "./BasicFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicFooter.vue?vue&type=script&setup=true&lang=js"

import "./BasicFooter.vue?vue&type=style&index=0&id=64ddf6d5&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64ddf6d5"]])

export default __exports__